var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -0.5 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "si-glyph si-glyph-document-copy",
    fill: "#176ac6",
    stroke: "#176ac6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "1087"), /*#__PURE__*/React.createElement("defs", null), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 0.000000)",
    fill: "#176ac6"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.02081276,0.0619997253 L0.025024413,0.0619997253 L0.025024413,12.9999997 L11.0162356,12.9999997 L11.0162359,2.99108856 L5.02081299,2.99108856 L5.02081276,0.0619997253 Z M1.99676514,10.0960693 L1.99676514,8.937 L9.01641846,9.03331344 L9.01641846,10.0298462 L1.99676514,10.0960693 Z M2.01104737,7.97650142 L2.01104737,7.00561523 L9.03167725,7.00561523 L9.03167725,7.97650142 L2.01104737,7.97650142 Z M9.01647949,6.03051761 L1.96008301,6.03051761 L1.96008301,4.938 L9.01647949,4.938 L9.01647949,6.03051761 Z",
    className: "si-glyph-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.06,0.062 L6.06,1.906 L10.812,1.906 L6.06,0.062 Z",
    className: "si-glyph-fill"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.063,2.062 L0.063,16 L10.9487307,15.9999997 L10.9487307,13.9790034 L1.94458011,13.9790036 L1.94458013,2.062 L0.063,2.062 Z",
    className: "si-glyph-fill"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.f4b3d0bf86f1130066e029a6ef440232.svg";
export { ForwardRef as ReactComponent };